// Helpers pour synchroniser les notifications "prestation_a_relancer"
// avec l'état des propositions liées.
import { supabase } from '@/integrations/supabase/client';

// Supprime la (les) notification(s) "prestation_a_relancer" liée(s) à la prestation
// donnée (UUID base). Le hook auto-create dans Relances.tsx en recréera une
// si le seuil d'inactivité est de nouveau dépassé (à partir de la date d'édit
// de la proposition, qui devient la nouvelle référence d'activité).
export async function resetRelanceNotificationForPrestation(prestationUuid: string | null | undefined) {
  if (!prestationUuid) return;
  try {
    const { data: prest } = await supabase
      .from('prestations')
      .select('numero')
      .eq('id', prestationUuid)
      .maybeSingle();
    const ref = (prest as any)?.numero || prestationUuid;
    // Supprime pour TOUS les users (le hook recréera pour chacun selon ses préférences)
    // Couvre à la fois le nouveau type unifié et l'ancien type legacy
    await supabase
      .from('notifications')
      .delete()
      .or('type.eq.action_a_suivre,type.eq.prestation_a_relancer')
      .filter('metadata->>prestation_ref', 'eq', ref);
  } catch (e) {
    console.warn('resetRelanceNotificationForPrestation failed', e);
  }
}
